// Modal.jsmailto:examsam001@student.co.za
import zIndex from '@material-ui/core/styles/zIndex';
import React, { useEffect } from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10; // Lower z-index
`;

const ModalContainer = styled.div`
  background: white;
  padding: 0px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  position: relative;
  max-width: 1000px;
  width: 100%;
  height: 80%;
  z-index: 11; // Lower z-index, but above overlay
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding: 10px;
  margin-bottom: 0px;
  background: #13a2d9;
  color: white;
  font-family: poppins, sans-serif !important;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.2em;
  cursor: pointer;
  color: white;
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;



const Modal = ({ path, pollName, compulsory, handleClose }) => {
  const handleMessage = (event) => {
    var obj = JSON.parse(event.data)
    if (obj.status == 'close-modal') {
      handleClose();
    }
  };

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <ModalOverlay >
      <ModalContainer style={{ zIndex: "1000 !important" }}>
        <Header >
          <h3 style={{paddingTop:10, paddingLeft:10,fontWeight:500}}>Poll - {pollName}</h3>
          {!compulsory && <CloseButton onClick={handleClose}>&times;</CloseButton>}
        </Header>
        <Iframe src={path} handle></Iframe>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default Modal;
